import { Component, input, signal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-report-overall-grades-new',
  standalone: true,
  templateUrl: './report-overall-grades-new.component.html',
  styleUrls: ['./report-overall-grades-new.component.css'],
  imports: [MatDividerModule, TranslatePipe]
})
export class ReportOverallGradesNewComponent {
  // Modern signal-based inputs
  capacityText = input<string | null | undefined>();
  capacity = input<number | null | undefined>();
  gamePerformanceText = input<string>('');
  gamePerformance = input<number>(0);
  positionText = input<string | null | undefined>();
  positionId = input<number | null | undefined>();
  totalQualityText = input<string>('');
  totalQuality = input<number>(0);
  playerTypeText = input<string | null | undefined>();
  playerType = input<number | null | undefined>();
  currentLevelRankingText = input<string | null | undefined>();
  currentLevelRanking = input<number | null | undefined>();

  // Computed signals for styling
  classesRankingBox = signal(['grayshading', 'redshading', 'yellowshading', 'greenshading', 'lightgreenshading', 'blueshading']);
  classesRankingBoxCapacity = signal(['grayshading', 'redshading', 'yellowshading', 'yellowshading', 'yellowshading', 'greenshading', 'greenshading', 'greenshading']);
  classesRankingBoxProjection = signal(['grayshading', 'redshading', 'yellowshading', 'yellowshading', 'greenshading', 'greenshading', 'greenshading', 'greenshading', 'greenshading']);

  floor(value: number): number {
    return Math.floor(value);
  }

  getGamePerformanceClass(): string {
    return this.classesRankingBox()[this.gamePerformance()];
  }

  getCapacityClass(): string {
    return this.classesRankingBoxCapacity()[this.floor(this.capacity() ?? 0)];
  }

  getProjectionClass(): string {
    return this.classesRankingBoxProjection()[this.totalQuality()];
  }

  shouldShowGamePerformance(): boolean {
    return this.gamePerformance() !== 0 && this.gamePerformance() !== null;
  }

  shouldShowPosition(): boolean {
    return this.positionId() !== 0 && this.positionId() !== null && this.positionId() !== undefined;
  }

  shouldShowCapacity(): boolean {
    return this.capacity() !== 0 && this.capacity() !== null && this.capacity() !== undefined;
  }

  shouldShowPlayerType(): boolean {
    return this.playerType() !== 0 && this.playerType() !== null && this.playerType() !== undefined;
  }

  shouldShowCurrentLevel(): boolean {
    return this.currentLevelRanking() !== 0 && this.currentLevelRanking() !== null && this.currentLevelRanking() !== undefined;
  }
}
